import Library from '../Library';
import { useSelectedClassroom } from '../Classrooms';
import SpinnerOverlay from '../SpinnerOverlay';
import ErrorDisplay from '../components/ErrorDisplay';
import { showIntercomNewMessage } from '../IntercomUtilityFunctions';

const SUPPORT_MESSAGE = "My account doesn't show any classrooms after logging in. Can you help?";

const LibraryRedirect = () => {
  const selection = useSelectedClassroom();

  if (selection.status === 'loading') {
    return <SpinnerOverlay isShow />;
  }

  if (selection.status === 'empty') {
    return (
      <ErrorDisplay
        contentTitle="We couldn't find your classrooms"
        contentSubtitle={() => (
          <div>
            Your account doesn&apos;t have any classrooms associated with it, so we can&apos;t show your library yet.
            This isn&apos;t something you did wrong. Please contact us and we&apos;ll get it fixed.
          </div>
        )}
        buttonText='Contact Peekapak'
        onButtonClick={() => showIntercomNewMessage(SUPPORT_MESSAGE)}
      />
    );
  }

  return <Library grade={selection.classroom.grade} />;
};

export default LibraryRedirect;
